var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddedProductIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#d6d6d6",
    fillOpacity: 0.8,
    stroke: "#d6d6d6",
    strokeOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2182 19.3334H15.7834C17.8277 19.3334 19.3959 18.595 18.9505 15.6232L18.4318 11.5958C18.1572 10.1129 17.2113 9.54541 16.3814 9.54541H9.59579C8.75368 9.54541 7.86276 10.1556 7.54545 11.5958L7.02676 15.6232C6.64842 18.2594 8.17397 19.3334 10.2182 19.3334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1267 9.39882C10.1267 7.80811 11.4163 6.51858 13.007 6.51858V6.51858C13.773 6.51533 14.5087 6.81735 15.0515 7.35786C15.5943 7.89836 15.8994 8.63282 15.8994 9.39882V9.39882",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2182 19.3334H15.7834C17.8277 19.3334 19.3959 18.595 18.9505 15.6232L18.4318 11.5958C18.1572 10.1129 17.2113 9.54541 16.3814 9.54541H9.59579C8.75368 9.54541 7.86276 10.1556 7.54545 11.5958L7.02676 15.6232C6.64842 18.2594 8.17397 19.3334 10.2182 19.3334ZM11.8103 12.4012C11.8103 11.987 11.4745 11.6512 11.0603 11.6512H11.0298C10.6156 11.6512 10.2798 11.987 10.2798 12.4012C10.2798 12.8155 10.6156 13.1512 11.0298 13.1512H11.0603C11.4745 13.1512 11.8103 12.8155 11.8103 12.4012ZM15.6974 12.4012C15.6974 11.987 15.3616 11.6512 14.9474 11.6512H14.9169C14.5027 11.6512 14.1669 11.987 14.1669 12.4012C14.1669 12.8155 14.5027 13.1512 14.9169 13.1512H14.9474C15.3616 13.1512 15.6974 12.8155 15.6974 12.4012Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddedProductIconWhite);
export default __webpack_public_path__ + "static/media/added-product-icon-white.fe26da5c8d74c10d56aa2a3d7ca40ff7.svg";
export { ForwardRef as ReactComponent };